import {FALLBACK_CURRENCIES} from "../../domain/currency.types";
import {toDomainCurrencies} from "../mappers/currency.mapper";
import {httpClientV2} from "../../../../infrastructure/http";
import {CurrencyRepository, GetCurrenciesResult} from "./currency.repository";

/**
 * v2 API implementation of CurrencyRepository.
 * Endpoint: general/currencies
 *
 * Pure TypeScript - no React imports.
 */
export class CurrencyRepositoryV2 implements CurrencyRepository {
  async getCurrencies(): Promise<GetCurrenciesResult> {
    try {
      const response = await httpClientV2.get<unknown>("general/currencies");
      const currencies = toDomainCurrencies(response);
      return {currencies, fromFallback: false};
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("[CurrencyRepository] Failed to fetch currencies:", error);
      return {currencies: [...FALLBACK_CURRENCIES], fromFallback: true};
    }
  }
}
